import { useEffect, useState } from "react";
import { API_BASE } from "../lib/api";

export type Provider = "anthropic" | "google" | "openai";

const PROVIDERS: { id: Provider; label: string }[] = [
  { id: "anthropic", label: "Anthropic" },
  { id: "google", label: "Google" },
  { id: "openai", label: "OpenAI" },
];

interface Model {
  id: string;
  name: string;
}

// Eén select met optgroup per provider — model kiezen zet meteen de provider.
export function ModelPicker({
  token,
  provider,
  model,
  onChange,
}: {
  token: string;
  provider: Provider;
  model: string | null;
  onChange: (provider: Provider, model: string | null) => void;
}) {
  const [models, setModels] = useState<Record<Provider, Model[]>>({
    anthropic: [],
    google: [],
    openai: [],
  });

  useEffect(() => {
    PROVIDERS.forEach(({ id }) => {
      fetch(`${API_BASE}/api/models?provider=${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((r): Promise<{ models?: Model[] }> => (r.ok ? r.json() : Promise.resolve({})))
        .then((d) => {
          if (Array.isArray(d.models) && d.models.length) {
            setModels((prev) => ({ ...prev, [id]: d.models! }));
          }
        })
        .catch(() => {});
    });
  }, [token]);

  return (
    <select
      value={model ? `${provider}|${model}` : ""}
      onChange={(e) => {
        const [p, m] = e.target.value.split("|");
        onChange((p as Provider) || "anthropic", m || null);
      }}
      title="AI-model"
      className="max-w-[10rem] rounded border border-border bg-bg px-2 py-1 text-xs"
    >
      <option value="">Standaard model</option>
      {PROVIDERS.filter((p) => models[p.id].length > 0).map((p) => (
        <optgroup key={p.id} label={p.label}>
          {models[p.id].map((m) => (
            <option key={m.id} value={`${p.id}|${m.id}`}>
              {m.name}
            </option>
          ))}
        </optgroup>
      ))}
    </select>
  );
}
